import { LESSON_STATUS } from '@yandex-int/k-common';
import { createSelector } from 'reselect';

import * as teamsSelectors from 'common.components/classes/selectors';
import { getIsLessonEvaluable, getLessonStatus } from 'common.components/lesson/selectors';
import { SPEC_COURSE_LESSON_MODE } from 'common.components/spec-course-lesson-view/typings';
import { SPEC_COURSE_LESSON_STATUS } from 'common.components/spec-course/typings';
import {
    getIsInStudentRegistrationLinkExperiment,
    getIsStudentRegistrationLinkAvailableInTeam,
    getSchoolId,
} from 'common.components/user/selectors';

import { getSpecCourseLessonStatus } from '../spec-course.lessons-page/selectors';

export const getSpecCourseLessonMode = createSelector(
    [
        getSpecCourseLessonStatus,
        getLessonStatus,
        teamsSelectors.getStudents,
        getIsLessonEvaluable,
        getSchoolId,
        getIsStudentRegistrationLinkAvailableInTeam,
        getIsInStudentRegistrationLinkExperiment,
    ],
    // eslint-disable-next-line complexity
    (
        specCourseLessonStatus,
        lessonStatus,
        students,
        isEvaluable,
        schoolId,
        isStudentRegistrationLinkAvailableInTeam,
        isInStudentRegistrationLinkExperiment
        // eslint-disable-next-line max-params
    ) => {
        if (students && students.length === 0) {
            if (specCourseLessonStatus === SPEC_COURSE_LESSON_STATUS.FINISHED) {
                return SPEC_COURSE_LESSON_MODE.NO_STUDENTS_FINISHED;
            }

            if (isInStudentRegistrationLinkExperiment) {
                if (!schoolId) {
                    return SPEC_COURSE_LESSON_MODE.NO_SCHOOL;
                }

                if (isStudentRegistrationLinkAvailableInTeam) {
                    return SPEC_COURSE_LESSON_MODE.INVITE_STUDENTS;
                }
            }

            return SPEC_COURSE_LESSON_MODE.NO_STUDENTS;
        }

        switch (specCourseLessonStatus) {
            case SPEC_COURSE_LESSON_STATUS.NOT_STARTED:
                return isEvaluable
                    ? SPEC_COURSE_LESSON_MODE.CONTROL_WORK_ASSIGNED
                    : SPEC_COURSE_LESSON_MODE.LESSON_ASSIGNED;
            case SPEC_COURSE_LESSON_STATUS.IN_PROGRESS:
                return isEvaluable
                    ? SPEC_COURSE_LESSON_MODE.CONTROL_WORK_IN_PROGRESS
                    : SPEC_COURSE_LESSON_MODE.LESSON_IN_PROGRESS;
            case SPEC_COURSE_LESSON_STATUS.FINISHED:
                if (lessonStatus === LESSON_STATUS.NOT_SOLVED) {
                    return SPEC_COURSE_LESSON_MODE.NOT_SOLVED;
                }
                return isEvaluable
                    ? SPEC_COURSE_LESSON_MODE.CONTROL_WORK_FINISHED
                    : SPEC_COURSE_LESSON_MODE.LESSON_FINISHED;
            case SPEC_COURSE_LESSON_STATUS.WAITING_FOR_RESULTS:
                return SPEC_COURSE_LESSON_MODE.WAITING_FOR_RESULTS;
            default:
                return SPEC_COURSE_LESSON_MODE.NO_STUDENTS;
        }
    }
);
